// Rèplica al frontend de la màquina d'estats de backend/FitxatgeHelper.php
// (fitEstatActual/fitTransicionsPermeses), necessària per Fase 3: quan hi ha
// events pendents de sincronitzar (encara no confirmats pel servidor), no ens
// podem refiar de "estatActual"/"transicionsPermeses" que va retornar l'últim
// ControlHorariEstat.php, perquè no els coneix. Cal fusionar-los i recalcular
// aquí, mantenint exactament les mateixes regles (CURRENT_TASK.md §16, §25).

const CH_TRANSICIONS_PER_TIPUS = {
  null: ["ENTRADA"],
  ENTRADA: ["INICI_PAUSA", "SORTIDA"],
  INICI_PAUSA: ["FI_PAUSA"],
  FI_PAUSA: ["INICI_PAUSA", "SORTIDA"],
  SORTIDA: [],
};

const CH_ESTAT_PER_TIPUS = {
  null: "SENSE_JORNADA_INICIADA",
  ENTRADA: "TREBALLANT",
  INICI_PAUSA: "EN_PAUSA",
  FI_PAUSA: "TREBALLANT",
  SORTIDA: "JORNADA_FINALITZADA",
};

// Combina els events ja confirmats pel servidor amb els pendents locals
// (encuats a IndexedDB però encara no sincronitzats), ordenats cronològicament.
// Si un pendent ja apareix entre els del servidor (mateix UUIDEvent, ja s'ha
// sincronitzat però encara no s'ha netejat la cua local) es descarta el
// duplicat local.
export function chFusionarEventsAmbPendents(eventsServidor, pendents) {
  const idsServidor = new Set((eventsServidor || []).map((e) => e.UUIDEvent));
  const pendentsFormatats = (pendents || [])
    .filter((p) => !idsServidor.has(p.uuidEvent))
    .map((p) => ({
      idRegistreJornadaEvent: `pendent-${p.uuidEvent}`,
      UUIDEvent: p.uuidEvent,
      TipusEvent: p.tipusEvent,
      DataHoraEvent: p.dataHoraEvent,
      TipusPausaEmpleats_idTipusPausaEmpleats: p.idTipusPausa || null,
      TipusPausaNom: p.nomTipusPausa || null,
      EstatGPS: p.estatGPS,
      Latitud: p.latitud,
      Longitud: p.longitud,
      _pendent: true,
      _errorPendent: p.estatLocal === "ERROR" ? p.ultimError : null,
    }));

  return [...(eventsServidor || []), ...pendentsFormatats].sort((a, b) =>
    a.DataHoraEvent < b.DataHoraEvent ? -1 : a.DataHoraEvent > b.DataHoraEvent ? 1 : 0
  );
}

// A partir d'una llista d'events ja fusionada i ordenada, retorna l'últim
// event, l'estat real i les transicions vàlides des d'aquell punt.
export function chEstatDesdeEvents(events) {
  const ultimEvent = events.length ? events[events.length - 1] : null;
  const ultimTipus = ultimEvent ? ultimEvent.TipusEvent : null;
  return {
    ultimEvent,
    estatActual: CH_ESTAT_PER_TIPUS[ultimTipus] ?? "SENSE_JORNADA_INICIADA",
    transicionsPermeses: CH_TRANSICIONS_PER_TIPUS[ultimTipus] ?? ["ENTRADA"],
  };
}
